import React from 'react';
import SingleTreatmentSelector from './SingleTreatmentSelector';
import {Grid } from '@mui/material';
import SmartField from './';
import { ButtonContinue } from '../mini_components';
import { Translate } from 'react-localize-redux';
import { green } from '@mui/material/colors';
import { useSnackBarState } from "../../../hooks";
import { Snackbar, Alert } from '@mui/material';

interface TreatmentInpatientSelectionProps {
  variant?: "standard" | "filled" | "outlined" | undefined;
  size?: string;
  language: string;
  typeMargin?: any;
  type: string;
  slaves?: object[];
  country?: string;
  template?: string;
  cancel?: () => void;
  updateElement?: (index: number, element: any) => void;
  elementSelected: (element: any) => void;
  onSave?: (treatments: any[]) => void;
  error: boolean;
  initialTreatments?: Array<any>;
  fieldInfo?: any;
  uuidSurvey?: string;
  uuidPatient?: string;
  uuidInvestigation?: string;
  idSubmission?: number;
  onSaveToDatabase?: (treatmentData: any) => Promise<void>;
  onUpdateDatabase?: (treatmentData: any) => Promise<void>;
  onDeleteDatabase?: (treatmentData: any) => Promise<void>;
}

function TreatmentInpatientSelection(props: TreatmentInpatientSelectionProps) {
  //return <SingleTreatmentSelector {...props} type="treatment_inpatient" />;
  
  return (

    <>   
      <SmartField 
        type="treatment_inpatient" 
        mode="form" 
        initialState={{listElements: props.initialTreatments, addingElements: false} as any} 
        printMode={false}
        label="Treatment"
        name="treatment_inpatient"
        typeMargin={props.typeMargin}
        forceDisplayElements={true}
        slaves={props.slaves || []}
        error={props.error}
        language={props.language}
        elementSelected={props.elementSelected}
        country={props.country || ""}
        fieldInfo={props.fieldInfo}
        uuidSurvey={props.uuidSurvey}
        uuidPatient={props.uuidPatient}
        uuidInvestigation={props.uuidInvestigation}
        idSubmission={props.idSubmission}
        onSaveToDatabase={props.onSaveToDatabase}
        onUpdateDatabase={props.onUpdateDatabase}
        onDeleteDatabase={props.onDeleteDatabase}
        updateElement={props.updateElement}
      />
  </>

  );
}

export default TreatmentInpatientSelection;